import { usePreferences } from './usePreferences'
import type { TagPreferenceType } from '@/lib/supabase'

export interface TagPreferences {
  included: string[]
  excluded: string[]
}

export const useTagPreferences = (userId: string) => {
  const { preferences, isLoading, updatePreference: genericUpdatePreference } = usePreferences('tag', userId)
  
  // Adapt the generic update function to maintain the same interface
  const updatePreference = {
    ...genericUpdatePreference,
    mutate: ({ tagName, preferenceType }: { tagName: string, preferenceType: TagPreferenceType | null }) => {
      return genericUpdatePreference.mutate({ itemName: tagName, preferenceType })
    },
    mutateAsync: async ({ tagName, preferenceType }: { tagName: string, preferenceType: TagPreferenceType | null }) => {
      return genericUpdatePreference.mutateAsync({ itemName: tagName, preferenceType })
    }
  }

  return {
    preferences,
    isLoading,
    updatePreference,
  }
}
